// FleetViewContext.jsx
import { createContext, useContext, useState } from "react";

const FleetViewContext = createContext();

// Controla a visão alternativa (issue #557) da tela "Minha Frota": mapa
// grande + grid completo sem paginação, ligada pelo switch no GlobalHeader.
// expandedView sempre volta a false ao sair da tela (reset feito pelo
// próprio Fleet.jsx no mount/unmount) — não é persistido de propósito.
export const FleetViewProvider = ({ children }) => {
  const [expandedView, setExpandedView] = useState(false);

  const toggleExpandedView = () => {
    setExpandedView((prev) => !prev);
  };

  return (
    <FleetViewContext.Provider
      value={{ expandedView, setExpandedView, toggleExpandedView }}
    >
      {children}
    </FleetViewContext.Provider>
  );
};

export const useFleetView = () => useContext(FleetViewContext);
